// @flow
import * as React from "react";
import { Route } from "react-router-dom";

import { THEME_RED } from "../commons/theme";
import displayPrice from "../commons/displayPrice";

import catalog from "./catalog";
import type { Bottle, Order } from "./catalog";
import DisplayRow from "./DisplayRow";
import Item from "./Item";
import OrderCompletion from "./OrderCompletion";

type Props = {
  order: Order,
  onChangeQty: (name: string, type: string, qty: number) => any
};

class OrderForm extends React.Component<Props> {
  onClickOrder = () => {
    location.hash = "order"; // eslint-disable-line
  };

  onCancelOrder = () => {
    location.hash = ""; // eslint-disable-line
  };

  render() {
    const { order, onChangeQty } = this.props;

    const total = Object.keys(order).reduce((acc, name) => {
      const bottle = catalog.find(bottle => bottle.name === name);
      if (!bottle) {
        return acc;
      }

      return (
        acc +
        Object.keys(order[name]).reduce((subAcc, type) => {
          const bottleType = bottle.types.find(
            bottleType => bottleType.type === type
          );
          if (!bottleType) {
            return subAcc;
          }

          return subAcc + order[name][type] * bottleType.price;
        }, 0)
      );
    }, 0);

    return (
      <div style={{}}>
        <DisplayRow
          type=""
          qty={"Quantité"}
          price={"Prix unitaire"}
          total={"Total TTC"}
          borders={false}
          style={{
            textAlign: "center",
            fontWeight: "bold",
            textTransform: "capitalize",
            marginBottom: 5
          }}
        />
        {catalog.map(({ name, img, types, html }: Bottle) => {
          return (
            <Item
              key={name}
              name={name}
              img={img}
              types={types}
              html={html}
              onChangeQty={onChangeQty}
              itemOrder={order[name]}
            />
          );
        })}

        <div style={{ textAlign: "right", marginTop: 30 }}>
          <div>
            TOTAL TTC
            <span
              style={{
                marginLeft: 6,
                border: "2px #333 solid",
                padding: 4
              }}
            >
              {displayPrice(total)}
            </span>
          </div>
          {total > 0 && (
            <div>
              <div
                style={{
                  display: "inline-block",
                  cursor: "pointer",
                  marginTop: 20,
                  padding: 20,
                  width: 115,
                  color: "#FFF",
                  fontWeight: "bold",
                  borderRadius: 5,
                  background: THEME_RED,
                  textAlign: "center"
                }}
                onClick={this.onClickOrder}
              >
                Commander
              </div>
            </div>
          )}
        </div>

        <Route
          path="/order"
          component={() => (
            <OrderCompletion
              total={total}
              order={order}
              onCancelOrder={this.onCancelOrder}
            />
          )}
        />
      </div>
    );
  }
}

export default OrderForm;



// WEBPACK FOOTER //
// ./src/NosBouteilles/OrderForm.js